webpackJsonp([257651663678295],{

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'A sole proprietorship is a unincorporated business owned by one individual, making it the simplest form of business to start and operate. There are over 20 million sole proprietorships operating in the United States and Canada, making it by far the most popular form of business ownership.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In a sole proprietorship, there is no difference between the individual and business for tax purposes.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Application Information',
	  fields: new Map([['firstName'], ['middleName'], ['lastName'], ['socialSecurity'], ['verifySocialSecurity'], ['title'], ['dba'], ['suffix', {
	    initial: 'MD'
	  }]])
	}, {
	  legend: 'Business Information',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Business Questions',
	  fields: new Map([['businessApplyReason'], ['businessActivity'], ['businessServices'], ['commonQuestionOne'], ['commonQuestionTwo'], ['commonQuestionThree'], ['commonQuestionFour'], ['businessAppliedBefore'], ['businessHireEmployees']])
	}, {
	  legend: 'Business Dates',
	  fields: new Map([['businessDateStart'], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify']])
	}];
	
	var SoleProprietorApplicationPage = function SoleProprietorApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Sole Proprietor Application',
	    documentType: _data.documentTypes.SOLE_PROPRIETOR,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = SoleProprietorApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sole-proprietor-application-js-1306173730bd44a03e47.js